export default "__VITE_ASSET__Bzs4xWAA__"